import FileViewer from './FileViewer';

export default FileViewer;
